<template >
  <div id="pdf">
    <MenuProductos :value="1"></MenuProductos>
    <v-data-table :headers="headers" :items="getProductosActivos" :search="search" class="elevation-1">
      <template v-slot:top>

        <v-row class="pa-3" dense>
          <v-col cols="12" md="2">
            <v-toolbar-title>EXISTENCIAS</v-toolbar-title>
          </v-col>
          <v-col cols="12" md="5">

            <v-text-field v-model="search" type="text" append-icon="mdi-magnify" label="Buscar por producto..." dense
              outlined hide-details></v-text-field>

          </v-col>
          <v-col cols="12" md="3">
            <!-- SeleccionarEstablecimiento -->
            <v-autocomplete v-model="establecimiento" :items="getEstablecimientosActivas" hide-details
              item-text="nombrecomercial" item-value="idestablecimiento" outlined dense @change="initialize"
              label="Seleccione Establecimiento / Bodega"></v-autocomplete>

          </v-col>
          <v-col cols="6" md="1" class="text-center">
            <v-btn color="green" dark @click="descargarExcel">
              <v-icon>mdi-microsoft-excel</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="6" md="1" class="text-center">
            <v-btn color="primary" dark @click="nueva">
              <v-icon>mdi-plus-thick</v-icon>

            </v-btn>
          </v-col>
        </v-row>


      </template>
      <template v-slot:[`item.tipo`]="{ item }">
        <p v-text="item.tipo"></p>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item.id)">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Recargar</v-btn>
      </template>
    </v-data-table>
    <!-- Dialog crear y editar existencias -->
    <v-dialog v-model="dialog" max-width="500">     
      <CrearEditarExistencia @setexistencia="setExistencias" :data="existencias" ref="existencias">
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn   color="primary" @click="crearEditar()">
                    Guardar Cambios
            </v-btn>

            <v-btn text @click="dialog = false">
              Cancelar
            </v-btn>

        </v-card-actions>
      </CrearEditarExistencia>
    </v-dialog>
  </div>
</template>

<script>
import {json2excel} from 'js2excel';
import CrearEditarExistencia from './CrearEditarExistencia.vue'
import Swal from 'sweetalert2'
import { mapGetters } from 'vuex'
import MenuProductos from './menu/menu.vue'

export default {
     name:'Existencias', 
     
     components:{
      MenuProductos,CrearEditarExistencia
     },
     data: () => ({
      search:'',
      establecimiento:1,
      dialog:false,
      existencias:{
        idarticulo:0,
        establecimiento:1,
      },
      cleardata:{
        establecimiento:1,
        idarticulo:0
      },
      headers:[
        { text: 'Cod.', align: ' d-none d-sm-table-cell' , value: 'articulo.codigo' },
        { text: 'Nombre', value: 'articulo.nombre',width: '50%'},
        { text: 'Ubicacion',align: 'center', value: 'ubicacion' },
        { text: 'Stock Minimo',align: 'center', value: 'stockminimo' },
        { text: 'Stock Actual',align: 'center', value: 'stockactual' },
        { text: 'Precio Compra',align: 'center', value: 'articulo.preciocompra' },
        { text: 'Precio Sugerido',align: 'center', value: 'articulo.preciosugerido' },
        { text: 'Precio Minimo',align: 'center', value: 'articulo.preciominimo'},
        { text: 'Actions',align: 'center', value: 'actions', sortable: false },
        ],
       
    }),

    computed: {
      ...mapGetters(['getProductosActivos','getTokenUser','getEstablecimientosActivas']),
      
    },

    async created () {
      await this.initialize()
    },

    methods: {  
      async initialize () {   
        await this.$store.dispatch('setExistencias',this.establecimiento)      
      },
      editItem (item) {
        
        this.existencias = Object.assign({}, item)
        // this.existencias.nombre = item.articulo.nombre
        // this.existencias.idarticulo = item.articulo.idarticulo
        // this.existencias.establecimiento = item.establecimiento.idestablecimiento

        this.dialog = true
       
      },
      nueva(){
        this.existencias = Object.assign({}, this.cleardata)
       // this.existencias.articulo.idarticulo = 0
        this.dialog = true
      },
      async crearEditar(){
        await this.$refs.existencias.save()
        await this.initialize()
       } ,
       setExistencias(){
           // await this.initialize()       
            this.dialog = false
        },

      async deleteItem (id) {
        
        Swal.fire({
          title: 'Esta Seguro?',
          text: "El registro será Eliminado!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, Eliminar!',
          cancelButtonText: 'Cancelar!'
        }).then( async (result) => {
          if (result.isConfirmed) {
            //Procedimiento para eliminarlo
            await this.$store.dispatch("deleteExistencias",id)
            await this.initialize()
          }
        })
       
              
      },
      
      print(){
        window.open("/reportes/inventarioprod.php","blank")
      },
      descargarExcel(){
        const elementos = []
     
        this.getProductosActivos.map((item)=> { 
          let articulo = {}
          articulo.codigo = item.articulo.codigo
          articulo.articulos = item.articulo.nombre
          articulo.establecimiento = item.establecimiento.nombrecomercial
          articulo.preciocompra = parseFloat(item.articulo.preciocompra)
          articulo.preciosugerido = parseFloat(item.articulo.preciosugerido)
          articulo.preciominimo = parseFloat(item.articulo.preciominimo)
          articulo.stockminimo = parseFloat(item.stockminimo)
          articulo.stockactual = parseFloat(item.stockactual)
          elementos.push(articulo)
        })

        const data = elementos
        try {
            json2excel({
                data,
                name: 'Control_Existencias_Productos',
                formateDate: 'yyyy/mm/dd'
            });
        } catch (e) {
            console.error('export error');
        }
      },
      //Notificaciones Swal
      alertDone(){
        Swal.fire({
          icon: 'success',
          title: 'Realizado',
          showConfirmButton: false,
          timer: 1500
        })
      },
      alertError(){
        Swal.fire({
          icon: 'error',
          title: 'No pudo realizarse la solicitud',
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    
}
</script>
<style lang="css">
.v-data-table td{
  font-size: 12px !important;
  height: 35px !important;
}

</style>
